import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import posts from "@_fakeData/posts.json";
import { NewsGridCard } from "@modules/study/common/news";
import styles from "./news_popular.module.scss";

export const NewsPopular = ({ data, title, customClasses }) => {
  const router = useRouter();
  const { query } = router;

  if (data && data?.length > 0) {
    return (
      <div
        className={`${styles.popular_posts_wrapper} ${
          customClasses?.rootClass ? customClasses?.rootClass : ""
        }`}
      >
        <h3
          className={`${styles.popular_title} ${
            customClasses?.titleClass ? customClasses?.titleClass : ""
          }`}
        >
          {title || "Popular Stories"}
        </h3>
        <div
          className={`${styles.popular_wrapper} ${
            customClasses?.wrapperClass ? customClasses?.wrapperClass : ""
          }`}
        >
          {data &&
            data?.length > 0 &&
            data.map((post, i) => (
              <NewsGridCard
                key={i}
                data={post}
                customClasses={{
                  cardClass: styles.news_card,
                  titleClass: styles.news_card_title,
                  featureImageClass: styles.news_feature_image_wrapper,
                }}
              />
            ))}
        </div>

        {/* <div className={styles.popular_wrapper}>
          {data &&
            data?.length > 0 &&
            data.map((post, i) => (
              <NewsGridCard
                key={i}
                data={post}
                customClasses={{
                  cardClass: styles.news_card,
                  titleClass: styles.news_card_title,
                  featureImageClass: styles.news_feature_image_wrapper,
                }}
              />
            ))}
        </div> */}

        {/* {data && data.length > 4 && (
          <div className={styles.btn_more_wrapper}>
            <Link  legacyBehavior href="#">
              <a className={`btn btn-outline-grey btn-md ${styles.btn_more}`}>
                More Stories
              </a>
            </Link>
          </div>
        )} */}
      </div>
    );
  } else {
    return <></>;
  }
};

export default NewsPopular;
